import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex max-width" }

import { IonRippleEffect, IonIcon } from "@ionic/vue";

import { CategoryPillProps } from "@/types/props";
import { CategoryPillEmits } from "@/types/emits";

import { pencilSharp, close, trashOutline } from "ionicons/icons";


export default /*@__PURE__*/_defineComponent({
  __name: 'CategoryPill',
  props: {
    outline: { type: Boolean },
    edit: { type: Boolean },
    deleteAble: { type: Boolean },
    disableRipple: { type: Boolean },
    supplierCategory: { type: Boolean },
    light: { type: Boolean },
    purple: { type: Boolean },
    ripple: { type: Boolean },
    wrap: { type: Boolean },
    removeFilter: { type: Boolean }
  },
  emits: ["edit", "remove", "delete"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-border px-2 category-pill cursor-pointer center-y ion-text-center", {
            'highlight-bg-coral bs-coral-full light-light-color': !__props.outline && !__props.supplierCategory && !__props.light && !__props.purple,
            'bs-purple-full highlight-bg-octo-purple': __props.supplierCategory,
            'bs-dashed': __props.outline,
            'card-ripple-parent ion-activatable': !__props.edit || __props.ripple,
            'highlight-bg-corallight bs-corallight-full': __props.light,
            'highlight-bg-purple bs-highlightpurple-full light-light-color': __props.purple
         }]),
    style: {"padding-top":"2px","padding-bottom":"2px"}
  }, [
    ((!__props.edit && !__props.disableRipple) || __props.ripple)
      ? (_openBlock(), _createBlock(_unref(IonRippleEffect), {
          key: 0,
          class: "border-ripple"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["max-width", {'overflow-ellipsis': !__props.wrap, 'break-word': __props.wrap}])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2),
      (__props.edit)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", {
              class: "ion-activatable round-ripple-parent ml-1 center-y",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('edit')))
            }, [
              _createVNode(_unref(IonIcon), { icon: _unref(pencilSharp) }, null, 8, ["icon"]),
              _createVNode(_unref(IonRippleEffect))
            ]),
            _createElementVNode("div", {
              class: "ion-activatable round-ripple-parent ml-1 center-y",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('remove')))
            }, [
              _createVNode(_unref(IonIcon), { icon: _unref(close) }, null, 8, ["icon"]),
              _createVNode(_unref(IonRippleEffect))
            ])
          ], 64))
        : _createCommentVNode("", true),
      (__props.deleteAble)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "ion-activatable round-ripple-parent ml-1 center-y",
            onClick: _cache[2] || (_cache[2] = ($event: any) => {$event.stopPropagation(); _ctx.$emit('delete')})
          }, [
            _createVNode(_unref(IonIcon), { icon: _unref(trashOutline) }, null, 8, ["icon"]),
            _createVNode(_unref(IonRippleEffect))
          ]))
        : _createCommentVNode("", true),
      (__props.removeFilter)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "ion-activatable round-ripple-parent ml-1 center-y",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('remove')))
          }, [
            _createVNode(_unref(IonIcon), { icon: _unref(close) }, null, 8, ["icon"]),
            _createVNode(_unref(IonRippleEffect))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})